///include /assets/js/app/p/spayment-item.js
///include /assets/js/app/s/basket.js
///include /assets/js/app/p/brand.js
///include /assets/js/app/p/description-template-compiler.js

"use strict"

class SOrderHostingPage {
    init() {
        this.view = new Vue({
            el: ".vue-wrapper",
            name: "order-hosting",
            data() {
                const vue = this
                return {
                    /** @type {SBasket} */
                    ///@ts-ignore
                    basket: AnyBasket.inst,
                    /** @type {?*} */
                    brand: null,
                    catalogue: UserCatalogue.inst,
                    format: Site.Format,
                    settings: SharedSettings.inst,
                    selectedPeriod: null,
                    get contact() {
                        return this.settings.contact;
                    },
                    get haveHostinglimits() {
                        if( this.hostingProducts ){
                            return this.hostingProducts.every( h => h.limits );
                        } else {
                            return false;
                        }
                    },
                    get hostingProducts() {
                        return this.products.filter(
                            p => ((this.catalogue && this.catalogue && this.catalogue.prefs && this.catalogue.prefs.splitWordpressHosting) ? (p.platform && p.platform != "wordpress") : true)
                        )
                    },
                    get notHiddenHostingProducts() {
                        return this.hostingProducts.filter(hp => !hp.hidden)
                    },
                    get loading() {
                        return !(
                            this.brand &&
                            this.catalogue.products &&
                            this.catalogue.isOpen !== null &&
                            this.haveHostinglimits
                        )
                    },
                    /**
                     * @type {SBHostingProduct[]}
                     */
                    get products() {
                        if(this.catalogue.products) {
                            //@ts-ignore
                            return this.catalogue.products.filter(
                                p => p instanceof SBStackUserPackageAllowanceProduct && p.forSale
                            )
                        } else {
                            return []
                        }
                    },
                    get wordpressProducts() {
                        return this.products.filter(
                            p => p.platform == "wordpress"
                        )
                    },
                    periodOptions(pricing) {
                        var seen = [];
                        var months = [];
                        pricing.forEach( (p) => {
                            if( !seen.includes(p.periodMonths) ){
                                seen.push(p.periodMonths);
                                months.push({
                                    text: this.intervalMonthsLabel(p.periodMonths),
                                    id: p.periodMonths
                                });
                            }
                        } );
                        return months;
                    }
                }
            },
            watch: {
                loading(v) {
                    if(!v) {
                        Vue.nextTick( () => {
                            $( ".page-loaded-content" ).fadeTo(200,1, function() {});
                        });
                    }
                }
            },
            methods: {
                bestSelectPeriod(pricing){
                    var period = +(this.selectedPeriod || (this.catalogue.prefs && this.catalogue.prefs.defaultHostingPeriodMonths) || 1);
                    if( period && pricing.some( p=> p.periodMonths == period ) ){
                        var p = pricing.find( p=> p.periodMonths == period );
                        return p.periodMonths;
                    } else {
                        return pricing[0].periodMonths;
                    }
                },

                compiledDescription(hp, lang = "en-GB"){
                    if( this.catalogue.prefs && this.catalogue.prefs.preferGB ){
                        Site.Format.preferGB = true;
                    }
                    var template = this.catalogue.productDescriptionFromCode(hp.code, translation.getActiveLanguage()) || "{{limits.compiledTable}}";

                    var limitsInUse = hp.limits ? Object.assign(hp.limits,{display:{}}) : {display:{}};
                    if( hp.limits ){
                        /**
                         * Decoupled for translation needs
                         * Converted to if statements for better readability...
                         */

                        /** Mailboxes template */
                        if(twigExtender.limit(hp.limits.mailboxes) === Infinity) {
                            limitsInUse.display.mailboxes = translation.sprintf(
                                translation.get(`group_template_unlimited_x_mailboxes`),
                                [Site.Format.GBorMB(hp.limits.maxMailboxSize * 2 ** 20)])
                        } else {
                            limitsInUse.display.mailboxes = translation.sprintf(
                                translation.get(`group_template_mailboxes_x_megabytes_mailboxes`),
                                [
                                    Site.Format.number(twigExtender.limit(hp.limits.mailboxes)),
                                    Site.Format.GBorMB(hp.limits.maxMailboxSize * 2 ** 20)
                                ]
                            )
                        }
                        /** Mailboxes template */

                        /** Domain template */
                        if(hp.limits.domains) {
                            if((twigExtender.limit(hp.limits.domains)+1) === Infinity) {
                                limitsInUse.display.domains = translation.get(`group_template_unlimited_domains`)
                            } else {
                                limitsInUse.display.domains = translation.sprintf(
                                    translation.get(`group_template_number_more_than_1_domains`),
                                    [Site.Format.number(twigExtender.limit(hp.limits.domains)+1)]
                                )
                            }
                        } else {
                            limitsInUse.display.domains = translation.get(`group_domain_description_1_domain`)
                        }
                        /** Domain template */

                        /** Web Space template */
                        if(twigExtender.limit(hp.limits.webspace) === Infinity) {
                            limitsInUse.display.webspace = translation.get(`group_template_unlimited_ssd`)
                        } else {
                            limitsInUse.display.webspace = translation.sprintf(
                                translation.get(`group_template_megabytes_ssd_web_space`),
                                [Site.Format.GBorMB(twigExtender.limit(hp.limits.webspace) * 2 ** 20)]
                            )
                        }
                        /** Web Space template */

                        /** Bandwith template */
                        if(twigExtender.limit(hp.limits.bandwidth) === Infinity) {
                            limitsInUse.display.bandwidth = translation.get(`group_template_unlimited_bandwidth`)
                        } else {
                            limitsInUse.display.bandwidth = translation.sprintf(
                                translation.get(`group_template_megabytes_month_bandwidth`),
                                [Site.Format.GBorMB(hp.limits.bandwidth * 2 ** 20)]
                            )
                        }
                        /** Bandwith template */

                        /** MySQL template */
                        limitsInUse.display.mysqlDatabases = translation.sprintf(
                            translation.get(`group_template_number_x_mysql_database`),
                            [Site.Format.number(twigExtender.limit(hp.limits.mysqlDatabases))]
                        )
                        /** MySQL template */

                        const t = Twig.twig({data: DefaultTemplateCompiler.getTemplateByType('package', lang), rethrow: true });
                        limitsInUse.compiledTable = t.render( Object.assign(twigExtender, {limits:limitsInUse,hp:hp}) );
                    }
                    var result = DefaultTemplateCompiler.compile(template,{limits:limitsInUse,hp:hp});
                    return result;
                },

                /**
                 * @param {number} m
                 * @returns {string}
                 */
                intervalMonthsLabel(m) {
                    if( m == 1 ){
                        return translation.get('global_shop_per_month')
                    }
                    return Catalogue.intervalMonthsLabel(m)
                },
                /**
                 * @param {number | "INF" | null} v
                 * @returns {number | null}
                 */
                limit(v) {
                    if(v == "INF") {
                        return Infinity
                    } else {
                        return v
                    }
                },

                monthLabel(pricing) {
                    var period = +(
                        this.selectedPeriod ||
                        (this.catalogue.prefs?.advertiseMonthlyEquivalent ? 1 : null) ||
                        (this.catalogue.prefs && this.catalogue.prefs.defaultHostingPeriodMonths) || 1
                    );
                    if (this.catalogue.prefs?.advertiseMonthlyEquivalent) {
                        return this.intervalMonthsLabel(1);
                    } else if( period && pricing.some( p=> p.periodMonths == period ) ){
                        var p = pricing.find( p=> p.periodMonths == period );
                        return this.intervalMonthsLabel(p.periodMonths);
                    } else {
                        return this.intervalMonthsLabel(pricing[0].periodMonths);
                    }
                },
                minorPrice(pricing) {
                    if (this.catalogue.prefs && this.catalogue.prefs.advertiseMonthlyEquivalent){
                        let price = pricing.map((p) => {
                          return p.price / (p.periodMonths == 0 ? 1 : p.periodMonths);
                        }).sort( (a, b) => {
                          return a - b;
                        })[0];
                        return this.format.priceTail(price);
                    } else {
                        var period = +(this.selectedPeriod || (this.catalogue.prefs && this.catalogue.prefs.defaultHostingPeriodMonths) || 1);
                        if( period && pricing.some( p=> p.periodMonths == period ) ){
                            var p = pricing.find( p=> p.periodMonths == period );
                            return this.format.priceTail(p.price)
                        } else {
                            return this.format.priceTail(pricing[0].price)
                        }
                    }
                },
                majorPrice(pricing) {
                    if (this.catalogue.prefs && this.catalogue.prefs.advertiseMonthlyEquivalent){
                        let price = pricing.map((p) => {
                          return p.price / (p.periodMonths == 0 ? 1 : p.periodMonths);
                        }).sort( (a, b) => {
                          return a - b;
                        })[0];
                        return Math.trunc(price);
                    } else {
                        var period = +(this.selectedPeriod || (this.catalogue.prefs && this.catalogue.prefs.defaultHostingPeriodMonths) || 1);
                        if( period && pricing.some( p=> p.periodMonths == period ) ){
                            var p = pricing.find( p=> p.periodMonths == period );
                            return Math.trunc(p.price)
                        } else {
                            return Math.trunc(pricing[0].price)
                        }
                    }
                }
            },
            components: {
                shopNav: ShopNav,
                "vue-select": VueSelect
            },
            mounted() {
                this.catalogue.assertExists()
            },
        })
    }
}
